/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import useContinuousImprovement from './helper';

export default function ContinuousImprovement() {
  const { t } = useTranslation();
  const container = useRef();
  const { filtersConfig } = useContinuousImprovement({ container });

  return (
    <Widget
      className="with-border-header no-px"
      title={t('Continuous Improvement ')}
      filtersConfig={filtersConfig}
    >
      <div className='flex flex-1 flex-column justify-content-center'>
        <div className='flex justify-content-center'>
          <Style ref={container} />
        </div>
      </div>
    </Widget>
  )
}
